var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.colors)?_c('div',{staticClass:"text-center"},_vm._l((_vm.colors),function(color){return _c('div',{key:color,staticClass:"d-inline-flex p-3 m-2 my-3",style:({ backgroundColor: color })})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }